<template>
  <v-row>
    <v-card
      class="pt-2 mx-auto"
      height="auto"
      width="98.5% "
    >
      <v-row>
        <v-col
          cols="12"
          md="3"
          class="d-flex justify-center align-center overflow-auto"
        >
          <v-list>
            <!-- <v-list-item
                dense
                class="px-0 mb-n2"
              >
                <v-avatar
                  rounded
                  size="110"
                  class="ml-3"
                >
                  <v-img
                    height="110"
                    width="110"
                    class=""
                    src="@/assets/images/pages/perfil.png"
                  ></v-img>
                </v-avatar>
              </v-list-item> -->
          </v-list>
        </v-col>

        <v-col
          cols="12"
          md="5"
          class="d-flex justify-center mb-6"
        >
          <v-list class="overflow-auto">
            <span class="text-lg font-weight-semibold text-uppercase"> Informações de perfil </span>
            <v-btn
              icon
              class="ml-5 text-left"
              color="primary"
              @click="isInfoDialogOpen = !isInfoDialogOpen"
            >
              <v-icon>
                {{ icons.mdiPencilBoxOutline }}
              </v-icon>
            </v-btn>

            <v-divider></v-divider>

            <v-list-item
              dense
              class="mx-auto px-0"
            >
              <span class="font-weight-medium me-2">Nome:</span>
              <v-chip
                label
                small
                outlined
                color="primary"
                class="mr-5"
              >
                {{ perfilData.nome }}
              </v-chip>

              <span class="font-weight-medium text-no-wrap me-2">Descrição:</span>
              <v-chip
                label
                small
                outlined
                color="primary"
              >
                {{ perfilData.descricao }}
              </v-chip>
            </v-list-item>
          </v-list>

          <perfil-info-edit
            :key="perfilData.id"
            :perfil-data="perfilData"
            :is-info-dialog-open.sync="isInfoDialogOpen"
            @refresh-data="$emit('refresh-data')"
          />
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="d-flex justify-end"
        >
          <v-list class="">
            <v-list-item class="ml-16">
              <v-btn
                icon
                color="error"
                :to="{ name: 'perfis' }"
              >
                <v-icon>{{ icons.mdiCloseCircleOutline }}</v-icon>
              </v-btn>
            </v-list-item>

            <v-list-item class="mr-2">
              <span class="font-weight-medium text-no-wrap">Status:</span>
              <v-chip
                v-if="perfilData.ativo"
                small
                class="ml-2"
                color="success"
                outlined
              >
                Ativo
              </v-chip>

              <v-chip
                v-else
                small
                class="ml-2"
                color="error"
                outlined
              >
                Inativo
              </v-chip>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCheck, mdiPencilBoxOutline, mdiCloseCircleOutline } from '@mdi/js'
import { avatarText, kFormatter } from '@core/utils/filter'
import PerfilInfoEdit from './PerfilInfoEdit.vue'

export default {
  components: {
    PerfilInfoEdit,
  },

  props: {
    perfilData: {
      type: Object,
      default: () => {},
    },
  },

  setup() {
    const isInfoDialogOpen = ref(false)

    return {
      avatarText,
      kFormatter,
      isInfoDialogOpen,
      icons: {
        mdiCheck,
        mdiPencilBoxOutline,
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>
